import http from './http';

export default {
  // 基础CRUD操作
  getList(params = {}) {
    return http.get('/o1/exam_controller/index', params );
  },
  
  getDetail(id) {
    return http.get('/o1/exam_controller/read', { id });
  },
  
  // 别名方法，兼容不同调用方式
  read(id) {
    return http.get('/o1/exam_controller/read', { id });
  },
  
  // 获取考试详情（详情页专用）
  getDetailInfo(id) {
    return http.get('/o1/exam_controller/detail', { id });
  },
  
  create(data) {
    return http.post('/o1/exam_controller/save', data);
  },
  
  update(data) {
    return http.post('/o1/exam_controller/update', data);
  },
  
  delete(id) {
    return http.post('/o1/exam_controller/delete', { id });
  },
  
  // 考试状态管理
  publish(id) {
    return http.post('/o1/exam_controller/change_status', { id, status: 'scheduled' });
  },
  
  start(id) {
    return http.post('/o1/exam_controller/change_status', { id, status: 'ongoing' });
  },
  
  finish(id) {
    return http.post('/o1/exam_controller/change_status', { id, status: 'finished' });
  },
  
  cancel(id) {
    return http.post('/o1/exam_controller/change_status', { id, status: 'cancelled' });
  },
  
  // 考试复制
  copy(id) {
    return http.post('/o1/exam_controller/copy', { id });
  },
  
  // 考试统计
  getStatistics() {
    return http.get('/o1/exam_controller/statistics');
  },
  
  // 学生管理
  getStudents(params) {
    return http.get('/o1/exam_controller/students', params);
  },
  
  addStudent(data) {
    return http.post('/o1/exam_controller/addStudent', data);
  },
  
  updateStudent(data) {
    return http.post('/o1/exam_controller/updateStudent', data);
  },
  
  removeStudent(data) {
    return http.post('/o1/exam_controller/removeStudent', data);
  },
  
  // 批量导入学生
  importStudents(data) {
    // 不再从FormData中提取exam_id，直接发送到原始接口
    return http.post('/o1/exam_controller/importStudents', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  // 下载学生导入模板
  downloadStudentTemplate(params) {
    return http.download('/o1/exam_controller/downloadStudentTemplate', params);
  },
  
  // 生成测试考生
  generateTestStudents(data) {
    return http.post('/o1/exam_controller/generateTestStudents', data);
  },
  
  // 清除测试考生数据
  clearTestStudents(data) {
    return http.post('/o1/exam_controller/clearTestStudents', data);
  },
  
  // 成绩统计
  getGradeStatistics(examId) {
    return http.get('/o1/exam_controller/gradeStatistics', { exam_id: examId });
  },
  
  // 批量操作
  batchDelete(ids) {
    return http.post('/o1/exam_controller/batch_delete', { ids });
  },
  
  batchChangeStatus(ids, status) {
    return http.post('/o1/exam_controller/batch_change_status', { ids, status });
  },
  
  // 模板管理
  getTemplates(params = {}) {
    return http.get('/o1/exam_controller/templates', { params });
  },
  
  saveAsTemplate(id, templateName) {
    return http.post('/o1/exam_controller/save_as_template', { id, template_name: templateName });
  },
  
  createFromTemplate(templateId, data) {
    return http.post('/o1/exam_controller/create_from_template', { template_id: templateId, ...data });
  },
  
  // 参与者管理
  getParticipants(examId, params = {}) {
    return http.get('/o1/exam_controller/participants', { exam_id: examId, ...params });
  },
  
  // 成绩统计
  getGradeStatistics(examId) {
    return http.get('/o1/exam_controller/grade_statistics', { exam_id: examId });
  },
  
  // 数据导出
  exportData(ids = [], format = 'excel') {
    return http.post('/o1/exam_controller/export', { ids, format });
  },
  
  // === 考试核心管理功能（对接后端ExamController）===
  
  // 获取考试参与者（暂时保留原路径，后续可扩展）
  getExamParticipants(examId, params) {
    return http.get(`/o1/exam/participants?exam_id=${examId}`, { params });
  },
  
  // 试卷管理（对接PaperController）
  getPapers(params = {}) {
    return http.get('/o1/paper_controller/index', params);
  },
  
  // 别名方法，兼容不同调用方式
  papers(params = {}) {
    return http.get('/o1/paper_controller/index', params);
  },
  
  getPaperDetail(paperId) {
    return http.get('/o1/paper_controller/read', { id: paperId });
  },
  
  createPaper(data) {
    return http.post('/o1/paper_controller/save', data);
  },
  
  updatePaper(paperId, data) {
    return http.post(`/o1/paper/update?id=${paperId}`, data);
  },
  
  deletePaper(paperId) {
    return http.delete(`/o1/paper/delete?id=${paperId}`);
  },
  
  // 试卷题目管理
  getPaperQuestions(paperId) {
    return http.get(`/o1/paper/questions?paper_id=${paperId}`);
  },
  
  addQuestionToPaper(data) {
    return http.post('/o1/paper/questions/add', data);
  },
  
  removeQuestionFromPaper(paperId, questionId) {
    return http.delete(`/o1/paper/questions/remove?paper_id=${paperId}&question_id=${questionId}`);
  },
  
  updatePaperQuestion(data) {
    return http.post('/o1/paper/questions/update', data);
  },
  
  // 考试和试卷关联
  bindPaperToExam(examId, paperId) {
    return http.post('/o1/exam/bindPaper', { exam_id: examId, paper_id: paperId });
  },
  
  unbindPaperFromExam(examId, paperId) {
    return http.post('/o1/exam/unbindPaper', { exam_id: examId, paper_id: paperId });
  },
  
  // 考试发布和状态管理
  publishExam(examId) {
    return http.post('/o1/exam/changeStatus', { id: examId, status: 'scheduled' });
  },
  
  startExam(examId) {
    return http.post('/o1/exam/changeStatus', { id: examId, status: 'ongoing' });
  },
  
  finishExam(examId) {
    return http.post('/o1/exam/changeStatus', { id: examId, status: 'finished' });
  },
  
  cancelExam(examId) {
    return http.post('/o1/exam/changeStatus', { id: examId, status: 'cancelled' });
  },
  
  // 考试模板管理
  getExamTemplates(params) {
    return http.get('/o1/exam/templates', { params });
  },
  
  saveAsTemplate(examId, templateName) {
    return http.post('/o1/exam/saveAsTemplate', { id: examId, template_name: templateName });
  },
  
  createExamFromTemplate(templateId, data) {
    return http.post('/o1/exam/createFromTemplate', { template_id: templateId, ...data });
  },

  // 发送登录信息
  sendStudentLoginInfo(data) {
    return http.post('/o1/exam_controller/sendStudentLoginInfo', data);
  },

  // 考试数据分析
  getExamData(params) {
    return http.get('/o1/exam_data/getExamData', params);
  },

  getStudentAnswers(params) {
    return http.get('/o1/exam_data/getStudentAnswers', params);
  },

  exportExamData(params) {
    return http.get('/o1/exam_data/exportExamData', params);
  },

  // 清除测试数据
  clearTestData(data) {
    return http.post('/o1/exam_controller/clearTestData', data);
  },

  // 批量清除所有测试数据
  clearAllTestData() {
    return http.post('/o1/exam_controller/clearAllTestData');
  },

  // ======== 违规记录相关接口 ========
  
  // 获取考试违规记录
  getViolations(params) {
    return http.get('/o1/exam_controller/getViolations', params);
  },

  // 获取违规类型选项
  getViolationTypes() {
    return http.get('/o1/exam_controller/getViolationTypes');
  },

  // 获取考试统计数据
  getStatistics(params) {
    return http.get('/o1/exam_controller/getStatistics', params);
  }
  
  // 注意：以下功能需要后续扩展对应的后端接口
  // 考生管理、阅卷管理、成绩管理等功能暂时保留旧接口
  // 建议后续创建专门的CandidateController、GradingController等
};
